import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Providers } from "@/providers";

export const Route = createRootRouteWithContext()({
  component: () => (
    <>
      <Providers>
        <Outlet />
      </Providers>
    </>
  ),
});
